import React, { useState, useEffect } from "react";
import banner from "data/Home/banner.json";
import { MAX_RESPONSIVE_MOBILE } from "store/constants";
import withDimension from "utils/withDimension";
import { getHeroBanner } from "services/Homepage";
import { imagePath } from "helper";

const HomeBanner = (props) => {
  const [heroBanner, setHeroBanner] = useState(null);

  async function fetchBanner() {
    const result = await getHeroBanner();

    setHeroBanner(result);
  }

  useEffect(() => {
    fetchBanner();
  }, []);

  return (
    <>
      <div className="w-full h-full min-h-screen relative flex items-start md:items-center justify-center">
        {heroBanner !== null && (
          <div
            className="w-full h-full absolute top-0 left-0 z-[2]"
            style={{
              backgroundImage: `url(${imagePath(
                heroBanner[0].id,
                heroBanner[0].banner,
                heroBanner[0].collectionName
              )})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        )}

        <div className="relative z-[2] flex items-center justify-center flex-col mt-[64px] md:mt-0 md:mb-[250px]">
          <img
            src="/images/main-logo.png"
            alt="Main logo"
            className="w-[184px] md:w-[220px] h-[112px] md:h-[134px]"
            loading="lazy"
          />
          <h5 className="text-16 leading-[20px] md:text-24 md:leading-normal text-primary-900 block mt-24 md:mt-32">
            {banner.title}
          </h5>
        </div>
      </div>
    </>
  );
};

export default withDimension(HomeBanner);
